<template>
  <svg
    class="date-time-setting-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M2.0631 6.71247H16.6523V4.10723C16.6523 4.02706 16.6189 3.95357 16.5521 3.88675C16.4853 3.81995 16.4118 3.78655 16.3317 3.78655H2.38378C2.30361 3.78655 2.23012 3.81995 2.1633 3.88675C2.0965 3.95357 2.0631 4.02706 2.0631 4.10723V6.71247ZM2.38378 19.9389C1.85739 19.9389 1.41183 19.7565 1.0471 19.3918C0.682365 19.0271 0.5 18.5815 0.5 18.0551V4.10723C0.5 3.58084 0.682365 3.13527 1.0471 2.77054C1.41183 2.40581 1.85739 2.22345 2.38378 2.22345H3.82668V0.019043H5.42985V2.22345H13.3256V0.019043H14.8888V2.22345H16.3317C16.858 2.22345 17.3036 2.40581 17.6683 2.77054C18.0331 3.13527 18.2154 3.58084 18.2154 4.10723V9.8006C17.9656 9.69106 17.7104 9.60255 17.4499 9.53507C17.1894 9.46761 16.9235 9.41451 16.6523 9.37576V8.27558H2.0631V18.0551C2.0631 18.1353 2.0965 18.2088 2.1633 18.2756C2.23012 18.3424 2.30361 18.3758 2.38378 18.3758H9.15936C9.24753 18.6643 9.35408 18.9372 9.47899 19.1944C9.6039 19.4516 9.74585 19.6997 9.90484 19.9389H2.38378ZM15.8107 20.981C14.5094 20.981 13.4025 20.5247 12.49 19.6122C11.5775 18.6997 11.1213 17.5929 11.1213 16.2916C11.1213 14.9903 11.5775 13.8835 12.49 12.971C13.4025 12.0585 14.5094 11.6022 15.8107 11.6022C17.1119 11.6022 18.2188 12.0585 19.1313 12.971C20.0438 13.8835 20.5 14.9903 20.5 16.2916C20.5 17.5929 20.0438 18.6997 19.1313 19.6122C18.2188 20.5247 17.1119 20.981 15.8107 20.981ZM17.5461 18.6764L18.1954 18.0271L16.2716 16.1032V13.2255H15.3497V16.48L17.5461 18.6764Z"
      fill="#2D9CDB"
    />
  </svg>
</template>

<script>
export default {
  name: "DateTimeSettingIcon",
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.date-time-setting-icon {
  path {
    fill: $aisea-blue;
  }
}
</style>
